import React from 'react';
import { useFormikContext } from 'formik';
import { Box, Text } from '@bechtel/gds';
import { t } from '@lingui/macro';
import { map } from 'lodash';
import { TimesheetReasons, FormikState } from '../types';
import { TimeSheetReason } from '~/components/molecules';
import { HoursInput } from '../hours-input';
import { Comment } from '../comment';
import { TimeHoursHeaderStyled } from '../styled';

export const TimesheetEntry = () => {
  const { values, isSubmitting } = useFormikContext<FormikState>();
  const { enteredHourTypes } = values;
  return (
    <>
      {map(enteredHourTypes, (hourType) => {
        return (
          <Box flexDirection={{ sm: 'column' }} key={hourType?.id}>
            <TimeHoursHeaderStyled data-testid="time-header-description">
              <Text size="400" weight="600" family="graphik">
                {hourType?.description}
              </Text>
            </TimeHoursHeaderStyled>
            <HoursInput
              name={`enteredHourTypes[${hourType?.id}].hours`}
              placeholder={hourType?.description}
              roundingIncrement={hourType?.roundingIncrement}
              isDisabled={isSubmitting}
            />
            <TimeSheetReason
              index={hourType?.id}
              name={`enteredHourTypes[${hourType?.id}].reason`}
              placeholder={t`Please Select`}
              isDisabled={!enteredHourTypes[hourType?.id]?.hours || isSubmitting}
            />
            {enteredHourTypes[hourType?.id]?.reason?.name === TimesheetReasons.TIMESHEET_REASON_OTHER && (
              <Box p={{ sm: '500' }}>
                <Comment
                  name={`enteredHourTypes[${hourType.id}].otherCommentDescription`}
                  placeholder={t`Add a comment...`}
                  isDisabled={isSubmitting}
                />
              </Box>
            )}
          </Box>
        );
      })}
    </>
  );
};
